import Cookies from 'js-cookie';

import { readLandingPageCookie } from 'src/lib/cookies';
import { getDomainUserId } from 'src/lib/snowplow';

interface FacebookCookieValues {
  facebook_cookie_click_id_fbc: unknown;
  facebook_cookie_browser_id_fbp: unknown;
}

interface SnowplowCookieValues {
  snowplow_cookie_domain_user_id?: string;
}

interface TrackingPayload extends Record<string, unknown> {
  facebook_cookie_click_id_fbc: unknown;
  facebook_cookie_browser_id_fbp: unknown;
  snowplow_cookie_domain_user_id?: string;
}

interface AttributionPayload {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
  extRefDomain?: string;
}

const FACEBOOK_FBC_COOKIE = '_fbc';
const FACEBOOK_FBP_COOKIE = '_fbp';

// The OAuth state blob is echoed back inside a URL, so it carries only the fields campaign
// attribution needs — the Facebook and Snowplow ids would just bloat the redirect.
const ATTRIBUTION_FIELDS: (keyof AttributionPayload)[] = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'extRefDomain',
];

export const getTrackingPayload = (): TrackingPayload => {
  const landingCookieValue = readLandingPageCookie();

  const facebookCookieValues: FacebookCookieValues = {
    facebook_cookie_click_id_fbc: Cookies.get(FACEBOOK_FBC_COOKIE),
    facebook_cookie_browser_id_fbp: Cookies.get(FACEBOOK_FBP_COOKIE),
  };

  const snowplowCookieValues: SnowplowCookieValues = {
    snowplow_cookie_domain_user_id: getDomainUserId(),
  };

  return {
    ...landingCookieValue,
    ...facebookCookieValues,
    ...snowplowCookieValues,
  };
};

export const getAttributionPayload = (): AttributionPayload => {
  const landingCookieValue = readLandingPageCookie();

  return ATTRIBUTION_FIELDS.reduce<AttributionPayload>((attribution, field) => {
    const value = landingCookieValue?.[field];

    return value ? { ...attribution, [field]: value } : attribution;
  }, {});
};
